import * as XLSX from 'xlsx';

interface ExportOptions {
	fileName?: string;
	sheetName?: string;
	imageColumns?: string[];
}

export function exportToExcel(data: any[], options: ExportOptions = {}): void {
	const {
		fileName = 'exportacao',
		sheetName = 'Planilha1',
		imageColumns = [],
	} = options;

	if (!data || data.length === 0) {
		console.error('Nenhum dado para exportar');
		return;
	}

	// Processar os dados para formato de texto simples
	const processedData = data.map((row) => {
		const newRow: any = {};

		Object.keys(row).forEach((key) => {
			let value = row[key];

			// Processar colunas de imagem
			if (imageColumns.includes(key) && Array.isArray(value)) {
				// Filtrar apenas URLs válidas
				const validUrls = value.filter(
					(url: any) =>
						typeof url === 'string' &&
						(url.startsWith('http://') ||
							url.startsWith('https://'))
				);

				if (validUrls.length > 0) {
					// Colocar cada URL em uma linha separada (ALT + ENTER no Excel)
					newRow[key] = validUrls.join('\n');
				} else {
					newRow[key] = '';
				}
			}
			// Processar outros valores
			else {
				if (value === undefined || value === null) {
					newRow[key] = '';
				} else if (Array.isArray(value)) {
					// Para arrays que não são de imagem, juntar com vírgula
					newRow[key] = value.join(', ');
				} else {
					// Converter para string e escapar caracteres especiais
					newRow[key] = String(value);
				}
			}
		});

		return newRow;
	});

	// Criar planilha
	const worksheet = XLSX.utils.json_to_sheet(processedData);

	// Ajustar altura das linhas para acomodar múltiplas URLs
	const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:A1');
	if (!worksheet['!rows']) worksheet['!rows'] = [];

	for (let row = range.s.r + 1; row <= range.e.r; row++) {
		let maxLines = 1;

		for (let col = range.s.c; col <= range.e.c; col++) {
			const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
			const cell = worksheet[cellAddress];

			if (cell && cell.v && typeof cell.v === 'string') {
				const lines = cell.v.split('\n').length;
				maxLines = Math.max(maxLines, lines);
			}
		}

		// Ajustar altura da linha baseada no número de linhas
		worksheet['!rows'][row] = { hpt: maxLines * 15 };
	}

	// Ajustar largura das colunas
	const headers = Object.keys(processedData[0] || {});
	const colWidths = headers.map((header) => {
		let maxLength = header.length;

		processedData.forEach((row) => {
			let value = row[header];
			if (value !== undefined && value !== null) {
				const strValue = String(value);
				// Pegar o comprimento da linha mais longa
				const lines = strValue.split('\n');
				const maxLineLength = Math.max(
					...lines.map((line) => line.length)
				);
				maxLength = Math.max(maxLength, Math.min(maxLineLength, 50));
			}
		});

		return { wch: Math.min(maxLength + 2, 60) };
	});

	worksheet['!cols'] = colWidths;

	// Criar workbook e exportar
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

	try {
		XLSX.writeFile(workbook, `${fileName}.xlsx`);
	} catch (error) {
		console.error('Erro ao exportar:', error);
	}
}
